module.exports = __webpack_public_path__ + "static/media/bs.cf40c6af.svg";